module.exports = __webpack_public_path__ + "img/payment_sucdceed.d0cc531b.png";